import { render, staticRenderFns } from "./add-comments-comp.vue?vue&type=template&id=4cddf378&"
import script from "./add-comments-comp.vue?vue&type=script&lang=js&"
export * from "./add-comments-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports